import { useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useAppDispatch, useAppSelector } from '@/app/store';
import { setUser } from '../authSlice';
import { auth } from '@/shared/utils/firebase';
import { mapFirebaseUserToUser } from '@/entities/user/model';
import type { Auth } from 'firebase/auth';

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const { error: reduxError } = useAppSelector(state => state.auth);

  const [firebaseUser, loading, firebaseError] = useAuthState(
    (auth ?? null) as Auth
  );

  useEffect(() => {
    if (!auth) return;
    if (!firebaseUser) {
      dispatch(setUser(null));
    }
  }, [firebaseUser, dispatch]);

  if (!auth) {
    return {
      user: null,
      isLoading: false,
      isAuthenticated: false,
      error:
        'Firebase Auth is not initialized. Please check your environment variables.',
    };
  }

  return {
    user: firebaseUser ? mapFirebaseUserToUser(firebaseUser) : null,
    isLoading: loading,
    isAuthenticated: !!firebaseUser,
    error: firebaseError?.message || reduxError,
  };
};
